import { NOMBRE_APP } from '../marca';

/** Logo B: barras de ranking y pelota, con el nombre en la fuente de la app. */
export function Marca({ grande = false }: { grande?: boolean }) {
  return (
    <span className={`inline-flex items-center gap-2 ${grande ? 'text-4xl' : 'text-2xl'} font-bold tracking-tight`}>
      <img src="/marca/simbolo.svg" alt="" width={grande ? 50 : 32} height={grande ? 44 : 28} className="shrink-0" />
      <span className="italic">{NOMBRE_APP}</span>
    </span>
  );
}
